module.exports = __webpack_public_path__ + "img/carrousel-flatpanel-12.c465b8f1.png";